import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';
import './algothon.css';

const AlgothonPage = () => {
  return (
    <div className="algothon-page">
      <header className="header">
        <h1>Susquehanna International Group Algothon 2024</h1>
        <h2>2nd Place | 600+ Submissions</h2>
      </header>

      <section className="achievement" style={{ fontFamily: 'Arial, sans-serif', padding: '20px', backgroundColor: '#f4f4f4', borderRadius: '8px' }}>
        <h3 style={{ color: '#2c3e50', fontSize: '24px', fontWeight: 'bold' }}>Overview</h3>
        <p style={{ fontSize: '16px', lineHeight: '1.6', color: '#34495e' }}>
          The <span style={{ fontWeight: 'bold', color: '#2980b9' }}>Algothon</span>, an <span style={{ fontWeight: 'bold', color: '#2980b9' }}>algorithmic trading hackathon</span> involved a series of workshops followed by the opportunity to design and build data-driven trading algorithms using advanced modelling and quantitative techniques. The dataset provided included data for <span style={{ fontWeight: 'bold', color: '#e67e22' }}>50 instruments spanning over 1,000 days</span>. My team earned <span style={{ fontWeight: 'bold', color: '#e74c3c' }}>second place</span> out of more than <span style={{ fontWeight: 'bold', color: '#e74c3c' }}>600 submissions</span> from across Australia and New Zealand. 
        </p>
        <p style={{ fontSize: '16px', lineHeight: '1.6', color: '#34495e' }}>
          As <span style={{ fontWeight: 'bold', color: '#27ae60' }}>Team Lead</span>, I was responsible for the <span style={{ fontWeight: 'bold' }}>research, design, and implementation</span> of the solution. Our efforts led to a score of <span style={{ fontWeight: 'bold', color: '#e74c3c' }}>609.35</span>, with the <span style={{ fontWeight: 'bold', color: '#e74c3c' }}>average score of all teams being 279</span> and the average excluding the top 3 was <span style={{ fontWeight: 'bold', color: '#e74c3c' }}>22</span>. Additionally, after the competition, I independently scored over <span style={{ fontWeight: 'bold', color: '#e74c3c' }}>700</span>.
        </p>
        <p style={{ fontSize: '16px', lineHeight: '1.6', color: '#34495e' }}>
          Our team, MMCandCo, was composed of myself, <span style={{ fontWeight: 'bold', color: '#2980b9' }}>Farhan</span>, and <span style={{ fontWeight: 'bold', color: '#2980b9' }}>Munawar</span>, all of whom contributed to our success.
        </p>
      </section>

      <section className="timeline">
        <h3>Timeline and Key Improvements</h3>
        <ul>
          <li><strong>Initial Submission:</strong> Encountered technical issues; submission unmarked.</li>
          <li><strong>Baseline:</strong> Used ensemble models for foundational strategy.</li>
          <li><strong>5.6x Improvement:</strong> 
            <ul>
              <li>Incorporated OpenAI’s GYM API for reinforcement learning.</li>
              <li>Feature-heavy and computationally expensive algorithm.</li>
            </ul>
          </li>
          <li><strong>14.5x Improvement:</strong>
            <ul>
              <li>Implemented Williams %R, reducing code complexity (364 to 165 lines).</li>
              <li>Switched to Random Forest for significant performance gains.</li>
            </ul>
          </li>
        </ul>
      </section>

      <section className="features">
        <h3>Features and Algorithm Highlights</h3>
        <ul>
          <li><strong>Features:</strong> RSI, MACD, Bollinger Bands, EMA, Williams %R</li>
          <li><strong>Model:</strong> Random Forest</li>
        </ul>
      </section>

  <h3>Code Overview</h3>
<ul style={{ fontSize: '16px', lineHeight: '1.6' }}>
  <li><strong>Data Loading:</strong> The code loads historical price data for multiple instruments.</li>
  <li><strong>Feature Extraction:</strong> It applies technical indicators like RSI, MACD, Bollinger Bands, and EMA to generate features for prediction.</li>
  <li><strong>Machine Learning Model:</strong> A Random Forest classifier is trained on the extracted features to predict future price movements.</li>
  <li><strong>Buy/Sell Signal Prediction:</strong> The model predicts buy or sell signals for each instrument, adjusting portfolio positions based on these predictions.</li>
  <li><strong>Data Preprocessing:</strong> Missing values are handled with imputation, and Recursive Feature Elimination (RFE) is used for optimal feature selection.</li>
  <li><strong>Dynamic Positioning:</strong> The model continuously adjusts trading positions based on market conditions and its predictions.</li>
</ul>

<p style={{ fontSize: '16px', lineHeight: '1.6', color: '#34495e' }}>
  <em>Note: The exact implementation and some specific features have not been provided as we may reuse the code in future competitions. </em>
</p>

      <section className="technical-tools">
  <h3>Technical Tools Used</h3>
  <ul>
    <li>Python (NumPy, Pandas, scikit-learn)</li>
    <li>Random Forest Classifier for machine learning</li>
    <li>SimpleImputer for handling missing data</li>
    <li>Data Splitting and Model Evaluation using Train-Test Split</li>
  </ul>
</section>
<section className="gallery">
        <h3>Gallery</h3>
        <Carousel>
          <div>
            <img src="/algothon_photos/team.jpeg" alt="Award Ceremony" />
            <p className="legend">Award Ceremony</p>
          </div>
          <div>
            <img src="/algothon_photos/email.png" alt="Winner's Email" />
            <p className="legend">Winner's Email</p>
          </div>
        </Carousel>
      </section>
    </div>
  );
};

export default AlgothonPage;
